/* eslint-disable no-undef */
/**
 * Erkennung von Outlook im Web in Desktop-Safari (kein Import aus autorun-sso → kein Zyklus mit auth-helper).
 */

function getOutlookHostName(): string {
  try {
    return Office.context?.mailbox?.diagnostics?.hostName ?? "";
  } catch {
    return "";
  }
}

function isMobileOutlookHost(): boolean {
  try {
    const hn = Office.context?.mailbox?.diagnostics?.hostName;
    return hn === "OutlookIOS" || hn === "OutlookAndroid";
  } catch {
    return false;
  }
}

/** Desktop-Safari (nicht Chrome/Edge/Fx auf iOS/Android). */
export function isLikelySafariBrowser(): boolean {
  if (typeof navigator === "undefined" || !navigator.userAgent) return false;
  const ua = navigator.userAgent;
  if (/Chrome|Chromium|CriOS|Edg|OPR|FxiOS|Android/i.test(ua)) return false;
  return /Safari/i.test(ua);
}

/**
 * Outlook im Web in Desktop-Safari: Office-SSO und OAuth im Taskpane-Iframe sind eingeschränkt.
 * Nur OutlookWebApp (nicht neues Outlook-Desktop), keine mobilen Hosts.
 */
export function isOutlookWebAppInDesktopSafari(): boolean {
  if (isMobileOutlookHost()) return false;
  return getOutlookHostName() === "OutlookWebApp" && isLikelySafariBrowser();
}
